import type { PartnerHotelOverview } from "@/types/partner-dashboard";

export type GuesteriaPartnerRevenueRow = {
  id: string;
  hotelBrand: string;
  hotelLogoId?: string;
  hotelLogoClassName: string;
  hotelLogoLetter: string;
  adminName: string;
  adminInitials: string;
  adminAvatarUrl?: string;
  partnerName: string;
  partnerLogoClassName: string;
  partnerLogoLabel: string;
  revenueEur: number;
  pms: string;
  billingPlan: string;
};

export const DEFAULT_LOGO_CLASS_NAME = "bg-zinc-500";
export const DEFAULT_PARTNER_LOGO_CLASS_NAME = "bg-emerald-600";

/**
 * Fixed "Guesteria Partners" identity — task 0028, contract 2026-09-28:
 * TENANT_ADMIN never sees a provider name. `overview.partnerProviderName`
 * can still carry a raw provider name (e.g. "Viator") from the backend, so
 * it is never rendered here.
 */
const GUESTERIA_PARTNERS_NAME = "Guesteria Partners";

function getInitials(name: string): string {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export function mapOverviewToRow(
  overview: PartnerHotelOverview,
): GuesteriaPartnerRevenueRow {
  const adminName = overview.hotelAdmin?.fullName ?? "-";
  const partnerName = GUESTERIA_PARTNERS_NAME;

  return {
    id: overview.hotelId,
    hotelBrand: overview.hotelName,
    hotelLogoId: overview.hotelLogoId ?? undefined,
    hotelLogoClassName: DEFAULT_LOGO_CLASS_NAME,
    hotelLogoLetter: overview.hotelName.charAt(0).toUpperCase(),
    adminName,
    adminInitials: getInitials(adminName) || "-",
    adminAvatarUrl: undefined,
    partnerName,
    partnerLogoClassName: DEFAULT_PARTNER_LOGO_CLASS_NAME,
    partnerLogoLabel: partnerName.charAt(0).toUpperCase() || "-",
    revenueEur: overview.totalPartnerRevenue,
    pms: overview.pmsType ?? "-",
    billingPlan: overview.subscriptionPlanName ?? "-",
  };
}
